import Jsona from 'jsona';

// eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types, @typescript-eslint/no-explicit-any
const serializeRequest = (requestBody: Record<string, any>) => {
  const jsonSerializer = new Jsona();
  const { includeNames = [], ...rest } = requestBody;
  return jsonSerializer.serialize({ stuff: rest, includeNames });
};

export default serializeRequest;
